/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Anschwerbehinderung1Inputs */



/**

* @param {_Field_Anschwerbehinderung1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_anschwerbehinderung1 = /** @type {((inputs?: _Field_Anschwerbehinderung1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Anschwerbehinderung1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Schwerbehinderung")
});
export { _field_anschwerbehinderung1 as "_field_anSchwerbehinderung" }